let breakNo = 0;

export function KeyedBreak() {
  breakNo += 1;
  return <br key={`${breakNo - 1}_break_key`} />;
}

export const textify = (text: string) => text.replace(/^\s+|\s+$/g, '').split('\n').flatMap((line) => [line, KeyedBreak()])